import { JobPortalApi } from "../api";

export const GetAllJobsAPI = JobPortalApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllJobs: builder.mutation({
      query: (offset) => {
        return {
          url: '',
          method: 'POST',
          body: JSON.stringify({
            "limit": 10,
            "offset": offset,
          })
        }
      },
      invalidatesTags: ['jobs']
    })
  })
})

export const { useGetAllJobsMutation } = GetAllJobsAPI;
